var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balldraw-module"},[_c('div',{staticClass:"k-balldraw",style:(_vm.aStyle)},[_c('div',{staticClass:"lottery-num",style:({
        fontSize: `${_vm.$unit(_vm.num.fontSize)}`,
        color: `${_vm.num.fontColor}`,
        bottom: `${_vm.$unit(_vm.num.bottom)}`
      })},[_vm._v(" 剩余"+_vm._s(_vm.prizeNum || 0)+"次抽奖机会 ")]),_c('div',{staticClass:"btn-history",style:({
        fontSize: `${_vm.$unit(_vm.history.fontSize)}`,
        color: `${_vm.history.fontColor}`,
        bottom: `${_vm.$unit(_vm.history.bottom)}`
      }),on:{"click":_vm.openPrizeRecord}},[_vm._v(" 查看中奖记录 ")]),_c('base-balldraw',{ref:"luckDrawPrize",staticClass:"wrapper",style:({
        bottom: `${_vm.$unit(_vm.draw.bgBottom)}`
      }),attrs:{"prize-list":_vm.list,"draw":_vm.draw,"egg":_vm.egg,"viewStatus":_vm.viewStatus},on:{"end-turns":_vm.endTurns,"start-turns":_vm.startTurns}})],1),(_vm.marquee.scrollSwitch)?_c('div',{staticClass:"marquee-box",style:(_vm.pStyle)},[_c('div',{staticClass:"marquee-scroll",style:({
        bottom: `${_vm.$unit(_vm.marquee.bottom)}`
      })},[_c('scroll-marquee',{attrs:{"speed":10,"standTime":2000,"list":_vm.scrollPrizes,"marquee":_vm.marquee}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }